<template>
    <div v-loading="loading">
        <div class="font12px mb20" v-if="appData.is_auth ==1">
            <span class="text-color-gray">已认证产品仅可进行绑定客户操作，若需修改产品标签请前往标签管理修改</span>
            <el-link 
                class="text-color-primary ml10" style="margin-top: -3px" type="primary"
                @click="handleLinkClick"
            >立即前往</el-link>
        </div>
        <div class="single-form-data">
            <el-form :form="formData" ref="form" :model="formData" :rules="rules" label-position="right" label-width="80px">
                <template v-for="(item, index) in dict">
                    <el-form-item :label="item.display_name" v-if="item.field_type === 'select'" :key="index"
                        :prop="item.name" filterable clearable>
                        <ESelect v-model="formData[item.name]" :placeholder="item.placeholder" style="width: 300px"
                            :disabled="disabled(item)">
                            <el-option v-for="item in getOptions(item) || []" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item :label="item.display_name" v-if="item.field_type === 'multiselect' && item.name !== 'customer_id'" :key="index"
                        :prop="item.name">
                        <ESelect v-model="formData[item.name]" :placeholder="item.placeholder" filterable clearable
                            multiple collapse-tags style="width: 300px" :disabled="disabled(item)">
                            <el-option v-for="item in getOptions(item) || []" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item :label="item.display_name" v-if="item.field_type === 'multiselect' && item.name === 'customer_id'" :key="index"
                        :prop="item.name">
                        <ESelect v-model="formData[item.name]" :placeholder="item.placeholder" filterable clearable
                            multiple remote collapse-tags reserve-keyword :loading="searchLoading"
                            :remote-method="appEntryCustomerList" style="width: 300px" :disabled="disabled(item)">
                            <!-- <p class="option-select">
                                <el-button type="text" @click="() => handleSelectAll(customerList)">全选</el-button>
                                <el-button type="text" @click="() => formData.customer = []">取消全选</el-button>
                            </p> -->
                            <el-option v-for="item in customerList" :key="item.customer_id || item.id" :label="item.company_name || item.name" :value="item.customer_id || item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item :label="item.display_name"
                        v-if="item.field_type === 'radio' && !!getOptions(item) && getOptions(item).length !== 0"
                        :key="index" :prop="item.name">
                        <el-radio-group v-model="formData[item.name]" :disabled="disabled(item)" style="width: 300px">
                            <el-radio v-for="item in getOptions(item) || []" :key="item.id" :label="item.id">
                                {{ item.name }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <div class="app_info_name" :key="index" v-if="shouldShow(item)">产品信息</div>

                    <el-form-item :label="item.display_name"
                        v-if="item.field_type === 'text' && !!getOptions(item) && getOptions(item).length !== 0"
                        :key="index" :prop="item.name">
                        <el-input v-model="formData[item.name]" :placeholder="item.placeholder" style="width: 300px"
                            :disabled="disabled(item)" />
                    </el-form-item>

                </template>

            </el-form>
        </div>
        <div class="btns" style="text-align: center;">
            <el-button @click="$emit('close')">取消</el-button>
            <el-button type="primary" :loading="saveLoading" @click="handleSubmit">保存</el-button>
        </div>
    </div>
</template>

<script>

import { validEmoji, validHtml } from '@/utils/validate'
import API from '@/api/baseInfo/customerAppV2.js';

import { errDataTipModal, errAuthModal } from './index'
export default {
    name: 'EditAppModal',
    props: ['cbs', 'type', 'appData'],
    data() {
        const validWordCount = (rule, value, callback) => {
            if (value.length > 100) {
                callback(new Error('最多输入100个字符'))
            } else {
                callback()
            }
        }
        const validContent = (rule, value, callback) => {
            const test = /\s/g
            if (validHtml(value) || validEmoji(value) || test.test(value)) {
                callback(new Error('不可包含空格、表情、html'))
            } else {
                callback()
            }
        };
        const validName = (rule, value, callback) => {
            const test = /^(?!-).+(?<!-)$/
            if (!test.test(value)) {
                callback(new Error('-不可在开头与结尾'))
            } else {
                callback()
            }
        }
        const validId = (rule, value, callback) => {
            const test = /^(?!.*__)[A-Za-z0-9]+(_[A-Za-z0-9]+)?$/
            if (test.test(value)) {
                callback()
            } else {
                callback(new Error('只可包含【数字、单词、_】，_不可在开头与结尾且_只能输入一个'))
            }
        }
        return {
            customerList: [],
            searchLoading: false,
            app_info_num: 0,
            formData: {
                // plat_id: '1',
                // app_type: '2',
                // package_type: '11',
                // game_classify: '3',
                // subproject_name:'',
                // subproject_id:'',
                // subprojet_content:''
            },
            rules: {
                // customer: [
                //     { required: true, message: '请绑定客户', trigger: 'blur' }
                // ],
                // plat_id: [
                //     { required: true, message: '请选择媒体', trigger: 'blur' }
                // ],
                // id: [
                //     { required: true, message: '请输入', trigger: 'blur' },
                //     { validator: validWordCount, trigger: 'blur' },
                //     { validator: validId, trigger: 'blur' },
                // ],
                // name: [
                //     { required: true, message: '请输入产品名称', trigger: 'blur' },
                //     { validator: validWordCount, trigger: 'blur' },
                //     { validator: validContent, trigger: 'blur' },
                //     { validator: validName, trigger: 'blur' },
                // ] ,
            },
            dict: [],
            loading: false,
            saveLoading: false
        }
    },
    computed: {
    },
    watch: {

    },
    mounted() {
        this.getDetail()
        this.$forceUpdate()
        this.getAppEntryCnfig()
    },
    methods: {
        handleLinkClick() {
            console.log(this.appData, 'appDataappData');
            const { subproject_name } = this.appData;
            // this.$emit('close');
            const { href } = this.$router.resolve({
                name: 'app_management_page',
                query: {
                    subproject_name,
                }
            });
            window.open(href, '_blank');
        },
        getDetail() {
            API.postAppEntryDetail({ 
                id: this.appData.id ,
                is_auth:this.appData.is_auth,
                customer_id: this.appData.customer_id,
                }).then(res => {
                const {customer_id} = res.data
                this.customerList = customer_id || []
                let formDataItem = res.data
                formDataItem['customer_id'] = (customer_id || []).map(item=>item.id)
                this.$set(this, 'formData', formDataItem)
            })
        },
        async getAppEntryCnfig() {
            try {
                this.loading = true
                const { data = [] } = await API.getAppEntryCnfigApi({
                    type: 'edit',
                    is_auth: this.appData.is_auth,
                });
                this.dict = data
                this.$nextTick(() => {
                    this.getRulesToFrom()
                })
            } catch (error) {
                this.$message.error(error.info)
            }finally {
                this.loading = false
            }
        },
        getRulesToFrom() {
            let vali_list = this.dict && this.dict.filter(ele => !!ele.validation)
            // let app_info_list = this.dict && this.dict.filter(ele => ele.ext_config['tag'] && ele.ext_config['tag'] === 'app_info')
            let rules = vali_list.reduce((pre, item) => {
                return {
                    ...pre,
                    [item.name]: item.validation.map(v=>{
                        if(v.validation_type === 'regex') {
                            v.pattern = new RegExp(v.pattern)
                        }
                        if(v.validation_type === 'required') {
                            return {
                                "message": v.message,
                                "required": v.required,
                                "trigger": v.trigger
                            }
                        }else{
                            return {...v}
                        }
                    })
                }
            }, {})
            
            this.$set(this, 'rules', rules)
            this.$nextTick(() => {
                this.$refs['form'].clearValidate()
            })
        },
        async appEntryCustomerList(search) {
            // 广州声动网络科技有限公司
            if (!this.formData['plat_id']) {
                return this.$message.error('请先选择媒体')
            }
            try {
                this.searchLoading = true
                const params = {
                    search,
                    plat_id: this.formData['plat_id']
                }
                const { data } = await API.getCompanySelector(params);

                this.customerList = data.list
            } catch (error) {
                this.$message.error(error.info)
            } finally {
                this.searchLoading = false
            }
        },
        handleSelectAll(list) {
            const data = [...(this.formData.customer || [])];
            data.push(...list.map(v => v.id));
            // 去重 赋值
            this.formData.customer = [...new Set(data)]
        },
        // 获取表单 下拉数据，并且是否显示
        getOptions(params) {
            const { dependencies, optionsSource, option } = params;
            if (dependencies.length === 0) {
                return option || optionsSource
            }
            let result = dependencies.map(item => {
                return this.formData[item]
            })
            let dict = result && result.reduce((prev, key, index, array) => {
                if (!Array.isArray(prev)) {
                    if (prev && prev[key] !== undefined) {
                        return prev[key];
                    } else {
                        return undefined;
                    }
                } else {
                    return prev
                }

            }, optionsSource)
            if (this.formData[params.name] && params.field_type !== 'text') {
                let icluced = dict && dict.some(item => typeof item === 'object' && item.id === this.formData[params.name])
                if (!icluced && dict && dict.length !== 0) {
                    console.log('not icluced', dict)
                    this.formData[params.name] = dict[0]?.id
                }
            }

            return dict
        },
        getValidationList(item) {
            API.getAppEntryValidation({type:'edit', ...item}).then(res=>{
                if(!res.data || res.data.length === 0) return
                this.$set(this, 'rules', res.data)
                this.$nextTick(() => {
                    this.$refs['form'].clearValidate()
                })
            }, error=>{
                this.$message.error(error.info)
            })
        },
        shouldShow(item) {
            let app_info_list = this.dict.filter(ele => ele.ext_config['tag'] && ele.ext_config['tag'] === 'app_info')
            let cur_id = app_info_list && app_info_list.length !== 0 ? app_info_list[0]['id'] : ''
            if (item.field_type === 'text' && item.ext_config['tag'] && item.ext_config['tag'] === 'app_info' && item.id === cur_id) {
                return true
            }
            return false
        },
        // 禁用
        disabled(item) {
            // if (this.type === 'edit') {
            //     return !item.ext_config['edit_editable']
            // } else if (this.type === 'add') {
            //     return !item.ext_config['add_editable']
            // }
            return !item.ext_config['edit_editable']
        },
        async getFormData() {
            return [
                { ...this.formData, plat_id: '20' }
            ]
            // const valid = await this.$refs['form'].validate();
            // if (valid) {
            //     return [
            //         {...this.formData, plat_id: '20'}
            //     ]
            // }
        },
        filterNonEmpty(obj) {
        // 过滤掉值为空的属性
            return Object.fromEntries(
                Object.entries(obj).filter(([key, value]) => value != null && value !== '')
            );
        },
        handleSubmit() {
            this.saveLoading = true
            this.$refs['form'].validate(async valid => {
                    if(valid) {
                        try {
                            // let result_formData = this.filterNonEmpty(this.formData)
                            const params ={
                                id: this.appData.id,
                                old_customer_id: this.appData.customer_id,
                                is_auth: this.appData.is_auth,
                                ...this.formData
                            }
                            await API.appEntryEditApi({app_info: params});
                            this.$message.success('修改成功')
                            this.cbs.onSubmit()
                        } catch (error) {
                            if(error.data?.error_list) {
                                errAuthModal({
                                    props: {
                                        list: error.data?.error_list
                                    }
                                });
                                return;
                            }
                            if (error.data?.length>0) {
                                const { vm } = errDataTipModal({
                                    width: '800px',
                                    props: {
                                        list: error.data.map(v=> {
                                            return {
                                                tip: v.error_msg,
                                                error_num: v.error_num
                                            }
                                        }),
                                        authList: [],
                                        entryList: [],
                                        remove: false,
                                        hasNum: false
                                    },
                                    cbs: {
                                        // onSubmit: callback
                                    }
                                })
                            }else if(error.data?.length==0) {
                                this.$message.error(error.info)
                            }else {
                                const { vm: vm_error } = errDataTipModal({
                                    width: '800px',
                                    props: {
                                        title: error.info,
                                        list: [
                                            {
                                                tip: '',
                                                error_num: error.data.err_list.error_num,
                                                index: error.data.err_list.error_num
                                            }
                                        ],
                                        authList: error.data.err_list.auth_err || [],
                                        entryList: error.data.err_list.entry_err || [],
                                        remove: false,
                                        hasNum: false
                                    },
                                    cbs: {
                                        // onSubmit: callback_error
                                    }
                                })
                                // this.$message.error(error.info)
                            }
                        } finally {
                            this.saveLoading = false
                        }
                    }else{
                        this.saveLoading = false
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.bold {
    font-weight: bold;
}

.information {
    border: 1px solid #ccc;
    padding: 12px 20px 0 20px;
    min-height: 140px;

    .info-tip {
        font-size: 12px;
        color: #aaa;
        padding-left: 50px;
    }
}

.single-form-data {
    max-height: 60vh;
    overflow-y: auto;
    .app_info_name {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid #dadada;
    }
}
</style>